import { render, staticRenderFns } from "./cdyyGlcdw.vue?vue&type=template&id=95867a36&scoped=true"
import script from "./cdyyGlcdw.vue?vue&type=script&lang=js"
export * from "./cdyyGlcdw.vue?vue&type=script&lang=js"
import style0 from "./cdyyGlcdw.vue?vue&type=style&index=0&id=95867a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95867a36",
  null
  
)

export default component.exports